// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-modules-interaction-components-ModalTimer---wrapper---28iLX","indicator":"src-modules-interaction-components-ModalTimer---indicator---2SwaE"};